// 버핏스코어 결과의 초상 — 점수 밴드 안에서 무작위, 단 분석 단위로 고정.
//
// 24장(assets/buffett/)은 파일명에 감정 밴드가 적혀 있다(band80to100 등).
// 높은 점수는 브이·엄지척·박수, 중간은 생각·책, 낮으면 놀람·절망 — 점수가
// 표정으로도 읽히게 한다.
//
// 무작위의 방식: 렌더마다 뽑으면 새로고침할 때마다 사진이 바뀌고, 딥링크로
// 공유한 화면과 받는 사람 화면이 달라진다. '기업|분석일' 을 시드로 밴드 안에서
// 뽑아 — 같은 분석은 항상 같은 사진, 다른 기업·다른 날은 다른 사진이다
// (pdfOwner 와 같은 원리).
import { buffettRating } from "./labApi";

// Vite 가 빌드 시 URL 로 치환한다 — 이미지는 결과가 뜰 때만 내려받는다
const _files = import.meta.glob<string>("../assets/buffett/*.webp", {
  eager: true, import: "default",
});

// 파일명의 밴드 표기 → 그 밴드의 이미지 URL 들 (rank 순 정렬)
const _byBand: Record<string, string[]> = {};
for (const path of Object.keys(_files).sort()) {
  const m = path.match(/_band(\w+?)_/);
  if (m) (_byBand[m[1]] ||= []).push(_files[path]);
}

// 등급 → 이미지 밴드. 점수 임계값을 여기 두지 않는다 — 등급표(buffettRating)가
// 단일 소스이고, 등급 문자열로 라우팅하면 임계값이 바뀌어도 여기는 그대로다.
// 하위 두 등급(평범한 기업·능력범위 밖)은 Under50 두 장을 같이 쓴다.
const _bandOf: Record<string, string> = {
  "위대한 기업": "80to100",
  "훌륭한 기업": "70to79",
  "좋은 기업": "50to69",
  "평범한 기업": "Under50",
  "능력범위 밖": "Under50",
};

/** 결정적 해시(FNV-1a) — 같은 시드는 항상 같은 값. */
export function seedHash(seed: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

/**
 * 점수 밴드 안에서 시드로 고른 초상 URL.
 * seed 는 '기업|분석일'(pdfOwner 와 같은 꼴)을 권장한다.
 */
export function buffettPortrait(score: number, seed: string): string {
  const band = _bandOf[buffettRating(score).rating] || "Under50";
  const pool = _byBand[band] || [];
  if (!pool.length) return "";
  return pool[seedHash(seed) % pool.length];
}

// 테스트용 — 밴드별 장수가 기대와 다르면(이미지 추가·삭제) 알아챈다
export const portraitPoolSizes = (): Record<string, number> =>
  Object.fromEntries(Object.entries(_byBand).map(([k, v]) => [k, v.length]));
